import React from 'react';

/* eslint-disable react/no-danger */
const renderUserWayScript = () =>
  typeof window !== 'undefined' &&
  !(window as any).UserWay &&
  window.location.hostname !== 'localhost' && (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          (function(d){
          var s = d.createElement("script");
          /* uncomment the following line to override default position*/
          /* s.setAttribute("data-position", 5);*/
          /* uncomment the following line to override default size (values: small, large)*/
          /* s.setAttribute("data-size", "large");*/
          /* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
          /* s.setAttribute("data-language", "language");*/
          /* uncomment the following line to override color set via widget (e.g., #053f67)*/
          /* s.setAttribute("data-color", "#4E6DF5");*/
          /* uncomment the following line to override type set via widget (1=person, 2=chair, 3=eye, 4=text)*/
          /* s.setAttribute("data-type", "1");*/
          /* s.setAttribute("data-statement_text:", "Our Accessibility Statement");*/
          /* s.setAttribute("data-statement_url", "http://www.example.com/accessibility")";*/
          /* uncomment the following line to override support on mobile devices*/
          /* s.setAttribute("data-mobile", true);*/
          /* uncomment the following line to set custom trigger action for accessibility menu*/
          /* s.setAttribute("data-trigger", "triggerId")*/
          s.setAttribute("data-account", "ltWJAQ2PPl");
          s.setAttribute("src", "https://cdn.userway.org/widget.js");
          (d.body || d.head).appendChild(s);

          var BREAKPOINT_MD = 992;
          var BOTTOM_OFFSET = '104px';
          var widgetEl = null;
          var originalBottom = null;
          var styleObserver;

          /* JPA-8233: UserWay's own script also repositions this widget (e.g. on the mobile
             on-screen keyboard opening/closing). If it fights our styleObserver over the same
             'bottom' property, each side's write can re-trigger the other synchronously, and a
             tight mutual loop between two independent scripts can exhaust the call stack. Two
             independent safeguards: (1) route every trigger through requestAnimationFrame so
             each reaction runs in its own task instead of nested inside the same call stack,
             and (2) cap how many times we'll fight back within one burst. */
          var MAX_OFFSET_ATTEMPTS = 30;
          var offsetAttempts = 0;
          var offsetScheduled = false;

          function applyOffset() {
            if (!widgetEl) return;
            if (originalBottom === null) {
              originalBottom = widgetEl.style.getPropertyValue('bottom');
            }
            var target = window.innerWidth < BREAKPOINT_MD ? BOTTOM_OFFSET : originalBottom;
            if (widgetEl.style.getPropertyValue('bottom') === target) {
              offsetAttempts = 0;
              return;
            }
            if (offsetAttempts >= MAX_OFFSET_ATTEMPTS) return;
            offsetAttempts += 1;
            if (target) {
              widgetEl.style.setProperty('bottom', target, 'important');
            } else {
              widgetEl.style.removeProperty('bottom');
            }
          }

          function scheduleApplyOffset() {
            if (offsetScheduled) return;
            offsetScheduled = true;
            window.requestAnimationFrame(function() {
              offsetScheduled = false;
              applyOffset();
            });
          }

          var mountObserver = new MutationObserver(function() {
            if (widgetEl) return;
            var el = d.querySelector('.userway_buttons_wrapper');
            if (!el) return;
            widgetEl = el;
            mountObserver.disconnect();
            applyOffset();
            styleObserver = new MutationObserver(scheduleApplyOffset);
            styleObserver.observe(widgetEl, { attributes: true, attributeFilter: ['style'] });
          });
          mountObserver.observe(d.body, { childList: true, subtree: true });

          window.addEventListener('resize', scheduleApplyOffset);
          })(document)
        `,
      }}
    />
  );

export default renderUserWayScript;
